import styled from "@emotion/styled";
import { UserIcon } from "../../general/UserIcon/UserIcon";
import { DeviceType, useDeviceType } from "hooks/useDeviceType";

export const ProfileIcon = () => {
  const isTablet = useDeviceType() === DeviceType.Tablet;
  return (
    <IconContainer>
      <UserIcon size={isTablet ? 56 : 80} borderRadius="14px" withBackground={false} />
    </IconContainer>
  );
};

// Sub-components

const IconContainer = styled.div`
  border-radius: 20px;
  margin-bottom: 10px;
`;
